import { Component, ReactNode } from 'react';

import Failure from './failure';

export default class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
    state = { hasError: false };

    // eslint-disable-next-line @typescript-eslint/member-ordering
    componentDidCatch(error: Error, errorInfo: never) {
        console.info('Error Boundary: ', error, errorInfo);
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return <Failure />;
        }

        return this.props.children;
    }
}
